import SettingsSidebar from "./presentation/components/SettingsSidebar.vue";
import MainSidebar from "./presentation/components/MainSidebar.vue";
/**
 * Sidebar Module - provides main navigation sidebar and settings sidebar components
 */
export class SidebarModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[SidebarModule] Registered");
        return {
            id: "sidebar",
            name: "Sidebar Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        // Sidebar typically doesn't provide routes, return empty array
        return [];
    }
    getNavigationItems() {
        // Sidebar can provide navigation items, but currently managed internally by component
        // Can be changed to unified management by Module in the future
        return [];
    }
    getComponent(slotName) {
        if (slotName === "main-sidebar") {
            return MainSidebar;
        }
        if (slotName === "sidebar") {
            return SettingsSidebar;
        }
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[SidebarModule] Unregistered");
        this.contracts = null;
    }
}
export default new SidebarModule();
